export const propMenuPrefetchEnabled = Math.random() >= 0.5;
